
<template>
  <div>
    <!-- 定义一个滚动范围的父div 并绑定ref=all（方便下方方法中取得此元素最左边位置），必要样式：overflow: hidden; display: flex; justify-content: left; -->
    <div class="carousel" ref="all">
      <!-- 循环数组数据，并绑定ref=demoItem(方便取得循环的每一个元素的最左边位置，并动态添加transform样式) -->
      <div
        v-for="(item, index) in images"
        :key="index"
        class="carousel-item"
        :style="'transform: translateX(' + item.translateNum + 'px)'"
        ref="demoItem"
        @mouseover="mouseOver"
        @mouseleave="mouseLeave">
        <div>
          <el-image :preview-src-list="imageSrcList" fit="contain" :src="item.url" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'demo',
  data() {
    return {
      images: [
        { url: require("../assets/images/certification/copyright/1、集中式储能充电系统电能调度分析软件开发系统V1.0.jpg") },
        { url: require("../assets/images/certification/copyright/2、集中矩阵式充电控制流开发系统V1.0.jpg") },
        { url: require("../assets/images/certification/copyright/3、智能充电桩嵌入式控制应用系统V1.0.jpg") },
        { url: require("../assets/images/certification/copyright/4、充电桩在线监测嵌入式软件V1.0.jpg") },
        { url: require("../assets/images/certification/copyright/5、充电桩手机定位服务APP软件V1.0.jpg") },
        { url: require("../assets/images/certification/copyright/6、充电桩计量计费管理系统V1.0.jpg") },
        { url: require("../assets/images/certification/copyright/7、动态分配直流快充系统V1.0.jpg") },
        { url: require("../assets/images/certification/copyright/8、充电桩一体化控制软件V1.0.jpg") },
        { url: require("../assets/images/certification/copyright/9、智能充电运营管理平台V1.0.jpg") },
        { url: require("../assets/images/certification/copyright/10、智能充电数据采集系统V1.0.jpg") },
        { url: require("../assets/images/certification/copyright/11、区块链柔性智能充电自动化控制系统V1.0.jpg") },
        { url: require("../assets/images/certification/copyright/12、柔性智能充电区块链平台软件V1.0.jpg") },
        { url: require("../assets/images/certification/copyright/13.光储充一体化设备安全运维监控管理系统V1.0.jpg") },
        { url: require("../assets/images/certification/copyright/14.基于物联网的光储充一体化系统V1.0.jpg") },
        { url: require("../assets/images/certification/copyright/15.一种带储能功能的V2G智能充放电系统V1.0.jpg") },
        { url: require("../assets/images/certification/copyright/16.一种微网下V2G的智能充放电系统V1.0.jpg") },
        { url: require("../assets/images/certification/copyright/17.一种应用于V2G中风光储充智能微网能量优化与碳资源管理系统V1.0.jpg") },
        { url: require("../assets/images/certification/copyright/18.智慧充电桩安全记录仪运维管控系统V1.0.jpg") },
        { url: require("../assets/images/certification/copyright/19.智慧光储充设备故障巡检监管平台V1.0.jpg") },
        { url: require("../assets/images/certification/copyright/20.智能化光储充一体化设备通信服务管控系统V1.0.jpg") },
        { url: require("../assets/images/certification/copyright/21.省市级充电基础设施监管平台.jpg") },
        { url: require("../assets/images/certification/copyright/22.直流充电桩控制系统软件.jpg") },
        { url: require("../assets/images/certification/copyright/23.交流充电桩控制系统软件.jpg") },
        { url: require("../assets/images/certification/copyright/24.非车载汽车充电模块软件.jpg") },
        { url: require("../assets/images/certification/copyright/25.全矩阵柔性智能充电堆运营系统.jpg") },
        { url: require("../assets/images/certification/copyright/26.环网智能充电堆运营系统.jpg") }

      ],
      imageSrcList:[],
      translateNum: 0,
      timer: null
    }
  },
  mounted() {
    this.search();
    this.imageSrcList = this.images.map(item=>item.url)
  },
  beforeDestroy() {
    // 销毁定时器，否则可能导致重载此组件时会有多个定时器同时执行，使得滚动变快
    window.clearTimeout(this.timer);
  },
  methods: {
    search() {
      for (let i = 0; i <this.images.length; i++) {
        this.$set(this.images[i],'translateNum',0);
      }
      this.$nextTick(() => {
        for (var j = 0; j < this.images.length; j++) {
          this.$set(this.images[j], 'indexLeft', this.$refs.demoItem[j].offsetLeft);
        }
        // 调用滚动定时器
        this.roll();
      })
    },

    roll() {
      this.timer = setInterval(() => {
        // 循环给每一个对象修改translateNum属性值，从而动态修改页面元素的transform样式，达到滚动的效果
        for (var i = 0; i < this.images.length; i++) {

          /**
           * 判断此元素是否即将超出父级元素carousel-item的显示区域
           * 1400 = 父级元素carousel的宽度 + 一个子元素carousel-item的宽度（如果元素有间距也需要带上）即 1200 + 180 + 20(间距)
           * 修改父级元素与子元素样式时需要留意此处也应当一起修改
           */
          if ((1200+166*(this.images.length-2)+20) - this.images[i].translateNum - this.images[i].indexLeft < 0) {

            /**
             * 如果超出，则将元素移动至父级元素显示区域的左方
             * 此处的200 对应着子元素carousel-item的样式宽度
             */
            this.$set(this.images[i], 'translateNum', this.$refs.all.offsetLeft - this.images[i].indexLeft - 200);
          }

          // 设置每个元素每次滚动的像素大小，像素越小越平滑,这里每次只移动一个像素
          this.$set(this.images[i], 'translateNum', this.images[i].translateNum + 1);

        }
      }, 18); // 30毫秒滚动一次，时间间隔越短滚动越平滑

    },

    /**
     * 鼠标悬停销毁定时器
     */
    mouseOver() {
      window.clearTimeout(this.timer);
    },

    /**
     * 鼠标离开再次执行定时器
     */
    mouseLeave() {
      this.roll();
    },


  }
}
</script>

<style lang="less" scoped>
.carousel {
  background-color: gray;
  width: 100%;
  height: 260px;
  margin: 20px auto;
  overflow: hidden;
  display: flex;
  justify-content: left;
  &::-webkit-scrollbar{
    display:none
  }
}

.carousel-item {
  width: 180px;
  height: 240px;
  text-align: center;
  margin: 10px 20px;
  //border: 4px solid #3a3a3b;

  .el-image{
    border: 1px solid #ccc;
    width: 166px;
    margin: auto;
  }
}
</style>
